import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { useWorkspaceStore } from '@/stores/useWorkspaceStore';

export interface SandboxTokenResponse {
  token: string;
}

export const getSandboxToken = async (storeId: string, workspaceId?: string): Promise<string> => {
  const wsId = workspaceId || useWorkspaceStore.getState().activeWorkspaceId;
  const url = wsId
    ? `/api/workspaces/${wsId}/stores/${storeId}/sandbox-token`
    : `/api/stores/${storeId}/sandbox-token`;

  const response = await apiClient.get(url);
  
  // Handle both plain text or JSON response
  if (typeof response.data === 'string') {
    return response.data;
  }
  return response.data?.token || response.data;
};

export const useSandboxToken = (storeId?: string, workspaceId?: string, enabled = true) => {
  const activeWorkspaceId = useWorkspaceStore((state) => state.activeWorkspaceId);
  const targetWorkspaceId = workspaceId || activeWorkspaceId;

  return useQuery({
    queryKey: ['sandbox-token', targetWorkspaceId, storeId],
    queryFn: () => getSandboxToken(storeId!, targetWorkspaceId || undefined),
    enabled: !!storeId && !!targetWorkspaceId && enabled,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};

